import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-aanbiedingenFR',
  templateUrl: '../../../../assets/html/fabrikanten_aanbiedingenFR.html',
  styleUrls: ['./aanbiedingenFR.component.css']
})
export class AanbiedingenFRComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
